// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ent-settings__pagination-cont[data-v-5962cdbe] {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  margin-top: 10px;\n  padding: 5px 10px;\n}\n.ent-settings__items-per-page[data-v-5962cdbe] {\n  margin-right: auto;\n}\n", ""]);
// Exports
module.exports = exports;
